<template>
    <j-modal
      :title="title"
      :width="width"
      :visible="visible"
      switchFullscreen
      @cancel="handleCancel"
      :fullscreen="true"
      cancelText="关闭">
  
      <template slot="footer">
        <a-button key="cancel" @click="handleOk">确定</a-button>
        <a-button key="cancel" @click="handleCancel">关闭</a-button>
      </template>
  
      
    </j-modal>
  </template>
  
  <script>
  import {mixinDevice} from '@/utils/mixin.js'
  import PageLayout from '@/components/page/PageLayout'
  import DetailList from '@/components/tools/DetailList'
  import {getAction, getFileAccessHttpUrl, postAction} from "@/api/manage";
  
  const DetailListItem = DetailList.Item
  
  let totalMountProd = 0.00
  
  export default {
    name: "SalesOrderDetailModal",
    components: {
    },
    data() {
      return {
      }
    },
    computed: {
    },
    updated() {
    },
    methods: {
      handleCancel() {
        this.visible = false
      },
    }
  }
  </script>
  
  <style lang="less" scoped>
  </style>
